module.exports = __webpack_public_path__ + "media/images/mypage/btn02_ov-d8c28de9a31ba3f26b1bad128defd88c.gif";